import { Button, HStack, Icon, VStack } from "@/shared/ui/primitives";
import { useTranslation } from "react-i18next";

export interface GyulCardProps {
	monthlyUsage: number;
	remainUsage: number;
	onRefill: () => void;
}

export const GyulCard = (p: GyulCardProps) => {
	const { t } = useTranslation();

	return (
		<HStack className="w-full px-[20px] py-[16px] gap-[10px] rounded-[20px] border border-outline bg-bg-weak/80 backdrop-blur-sm shadow-[0_8px_32px_rgba(15,23,42,0.06)]">
			<VStack className="w-full gap-[2px]">
				<HStack className="w-full justify-start text-pm-strong text-sm font-medium">
					<Icon name="GyulLeft" width={18} height={18} />
					<span>{t("workflow.monthlyUsage")}</span>
				</HStack>
				<span className="w-full text-ct-strong text-lg font-medium">
					{p.monthlyUsage.toLocaleString()}{t("common.amount")}
				</span>
			</VStack>
			<VStack className="w-full gap-[2px]">
				<HStack className="w-full justify-start text-pm-strong text-sm font-medium">
					<Icon name="GyulLeft" width={18} height={18} />
					<span>{t("workflow.remainUsage")}</span>
				</HStack>
				<span className="w-full text-ct-strong text-lg font-medium">
					{p.remainUsage.toLocaleString()}{t("common.amount")}
				</span>
			</VStack>
			<Button className="shrink-0" onClick={p.onRefill}>
				{t("workflow.refill")}
			</Button>
		</HStack>
	);
};
